// announcement-detail-modal.component.ts
import { TextFieldModule } from '@angular/cdk/text-field';
import {
    CommonModule,
    DatePipe,
    NgClass,
    NgForOf,
    TitleCasePipe,
} from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
    FormControl,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChip, MatChipSet } from '@angular/material/chips';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import {
    MatDrawer,
    MatDrawerContainer,
    MatDrawerContent,
} from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterOutlet } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TranslocoModule, TranslocoPipe } from '@ngneat/transloco';
import {
    Category,
    StatusEnum,
} from 'app/modules/categories/list-categories/category';
import { CategoryService } from 'app/modules/categories/list-categories/category.service';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import * as phosphorIcons from '@ng-icons/phosphor-icons/regular';
import swal from 'sweetalert2';
import { AnnouncementCard1 } from '../announcement-cards/announcement-cards.component';
import { PermissionService } from '../permission-modal/permission.service';
@Component({
    selector: 'app-category-modal-component-modal',
    templateUrl: './category-modal.component.html',
    styleUrls: ['./category-modal.component.scss'],
    standalone: true,
    imports: [
        MatButtonToggleModule,
        FormsModule,
        ReactiveFormsModule,
        FuseCardComponent,
        MatButtonModule,
        MatIconModule,
        RouterLink,
        NgClass,
        MatMenuModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatInputModule,
        TextFieldModule,
        MatDividerModule,
        MatTooltipModule,
        TitleCasePipe,
        NgForOf,
        MatDrawerContainer,
        MatDrawerContent,
        MatDrawer,
        MatTableModule,
        MatPaginatorModule,
        RouterOutlet,
        DatePipe,
        MatSelectModule,
        AnnouncementCard1,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatSelectModule,
        FormsModule,
        CommonModule,
        MatButtonToggleModule,
        FormsModule,
        FuseCardComponent,
        MatButtonModule,
        MatIconModule,
        RouterLink,
        CommonModule,
        NgClass,
        MatMenuModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatInputModule,
        TextFieldModule,
        MatDividerModule,
        MatTooltipModule,
        TitleCasePipe,
        NgForOf,
        MatDrawerContainer,
        MatDrawerContent,
        MatDrawer,
        MatTableModule,
        MatPaginatorModule,
        RouterOutlet,
        DatePipe,
        MatSelectModule,
        TranslocoModule,
        TranslocoPipe,
        MatDialogActions,
        MatChipSet,
        MatChip,
        MatDialogContent,
        MatAutocompleteModule,
        NgIconComponent
    ],
    viewProviders: [provideIcons(phosphorIcons)]
})
export class CategoryDetailModalComponent implements OnInit {
    form: FormGroup;
    category: Category;
    icons: string[] = Object.keys(phosphorIcons);
    filteredIcons: string[] = this.icons;

    constructor(
        public dialogRef: MatDialogRef<CategoryDetailModalComponent>,
        public permissionService: PermissionService,
        private _categoryService: CategoryService,
        @Inject(MAT_DIALOG_DATA) public data: Category,
        private _fuseConfirmationService: FuseConfirmationService,
    ) {
        this.category = new Category();
    }

    ngOnInit(): void {
        if (this.data != null) {
            this.category = this.data;
        }

        this.loadData();
    }

    loadData() {
        this.form = new FormGroup(
            {
                name: new FormControl(this.category?.name, [
                    Validators.required,
                ]),
                slug: new FormControl(this.category?.slug, [
                    Validators.required,
                ]),
                subcategory: new FormControl(this.category.subcategory, []),
                icon: new FormControl(this.category.icon ? this.category.icon.replace('heroicons_outline:', '').replace('feather:', '') : null),
                priority_order: new FormControl(this.category.priority_order || 0),
            },
            { updateOn: 'change' }
        );

        this.form.get('icon')?.valueChanges.subscribe(value => {
            this.filteredIcons = this.icons.filter(icon => icon.toLowerCase().includes(value?.toLowerCase() || ''));
        });
    }

    save(): void {
        if (
            (this.category.id == null && this.permissionService.can('create_category')) ||
            (this.category.id != null && this.permissionService.can('edit_category'))
        ) {
            this._fuseConfirmationService.open({
                title: "Permissão negada",
                message: "Você não tem permissão para essa ação.",
                icon: {
                    show: true,
                    name: 'heroicons_solid:x-circle',
                    color: "warning",
                },
                actions: {
                    cancel: {
                        show: false
                    },
                    confirm: {
                        label: "OK",
                    }
                },
                dismissible: true
            })
            return
        }

        if (this.form.invalid) {
            swal.fire({
                title: 'Formulário Inválido',
                text: 'Campos Inválidos',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'OK',
            });
        } else {
            this.form.disable();
            const formData = this.form.value;

            this.category = {
                ...this.category,
                name: formData.name,
                slug: formData.slug,
                subcategory: Array.isArray(formData.subcategory)
                    ? formData.subcategory
                    : typeof formData.subcategory === 'string'
                        ? formData.subcategory
                            .split(',')
                            .map((item) => item.trim())
                            .filter((item) => item.length > 0)
                        : [],
                featured: true,
                status: StatusEnum.ACTIVE,
                priority_order: formData.priority_order || 0,
                icon: formData.icon ? formData.icon : null,
            };

            this._categoryService.save(this.category, (_result, resp) => {
                if (resp != null) {
                    this.category = resp;
                    swal.fire({
                        title: 'Sucesso',
                        text: 'Categoria Cadastrada com sucesso',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'Ok',
                        cancelButtonText: 'Cancelar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.close();
                        }
                    });
                } else {
                    swal.fire({
                        title: 'Erro',
                        text: 'Erro ao cadastrar a categoria',
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Ok',
                        cancelButtonText: 'Cancelar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.close();
                        }
                    });
                }
                this.form.enable();
            });
        }
    }

    close() {
        this.dialogRef.close();
    }
}
